import { Search } from '@/DTOS/Configuration/Search';
import { LabelEnumSearch } from '@/DTOS/LabelEnum/Search';
import request from '../../utils/request';

const ConfigurationService = {
  searchCompanyRanks: (search: LabelEnumSearch) => {
    return request('/configuration/searchCompanyRanks', {
      method: 'POST',
      body: JSON.stringify({ request: { ...search } }),
    });
  },

  searchOfferStatus: (search: LabelEnumSearch) => {
    return request('/configuration/searchOfferStatus', {
      method: 'POST',
      body: JSON.stringify({ request: { ...search } }),
    });
  },

  searchContractStatus: (search: LabelEnumSearch) => {
    return request('/configuration/searchContractStatus', {
      method: 'POST',
      body: JSON.stringify({ request: { ...search } }),
    });
  },

  searchContractInterventionTypes: (search: any) => {
    return request('/configuration/searchContractInterventionType', {
      method: 'POST',
      body: JSON.stringify({ request: { ...search } }),
    });
  },

  searchContractInterventionTariffType: (search: any) => {
    return request('/configuration/searchContractInterventionTariffType', {
      method: 'POST',
      body: JSON.stringify({ request: { ...search } }),
    });
  },

  searchPmOfferStatus: (search: LabelEnumSearch) => {
    return request('/configuration/searchPmOfferStatus', {
      method: 'POST',
      body: JSON.stringify({ request: { ...search } }),
    });
  },

  searchPmContractStatus: (search: LabelEnumSearch) => {
    return request('/configuration/searchPmContractStatus', {
      method: 'POST',
      body: JSON.stringify({ request: { ...search } }),
    });
  },

  searchPmContractProjectStatus: (search: LabelEnumSearch) => {
    return request('/configuration/searchPmContractProjectStatus', {
      method: 'POST',
      body: JSON.stringify({ request: { ...search } }),
    });
  },

  searchPmOfferContractType: (search: LabelEnumSearch) => {
    return request('/configuration/searchPmOfferContractType', {
      method: 'POST',
      body: JSON.stringify({ request: { ...search } }),
    });
  },

  searchUserRols: (search: LabelEnumSearch) => {
    return request('/configuration/searchUserRols', {
      method: 'POST',
      body: JSON.stringify({ request: { ...search } }),
    });
  },

  searchConfiguration: (search: Search) => {
    return request('/configuration/searchConfiguration', {
      method: 'POST',
      body: JSON.stringify({ request: { ...search } }),
    });
  },
};

export default ConfigurationService;
